<div>
  <label *ngIf="label" [attr.for]="identifier">
    {{label}}
    <pmv-mini-loading [isLoading]="isLoading"></pmv-mini-loading>
  </label>
  <p-dropdown [options]="_options" [(ngModel)]="value" styleClass="form-control" [id]="identifier" [disabled]="disabled || !_options || !_options.length"
    [filter]="filter" (onChange)="changeEvent($event)" (onBlur)="blurEvent($event)" (onFocus)="focusEvent()" [emptyFilterMessage]="emptyFilterMessage"></p-dropdown>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵn.html